import React, { Component } from 'react';
import { Table, Button, Icon, Input } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import $ from "jquery";
import {
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
} from 'semantic-ui-react'
import { Link } from "react-router-dom";
import serverName from '../../functions/server';

class Specification extends Component {

  state = {
    specification: [],
    specificationData: []
  }

  getSpecification() {
    let variantId = 0;
    this.props.data.map((c) => {
      if (c.type == "products") {
        variantId = c.variant_id;
      }
    })
    let context = this;
    let categorys = [];
    let category = this.props.category;
    var url_string = window.location.href;
    var url = new URL(url_string);
    var shopId = url.searchParams.get("shopId");
    if (category.length == 0) {
      alert('Select Category!!!'); return;
    }
    category.map((v) => {
      let mastercategory = v.split('->')[1];
      let secondarycategory = v.split('->')[0];
      categorys.push({ mastercategory, secondarycategory  })
    })
    let data = { mastercategory: this.props.mastercategory, category: categorys, shopId, productId: this.props.productId, variantId: !variantId ? 0 : variantId };
    $.ajax({
      type: 'POST', data: data, url: serverName() + '/specification/getvariants.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          if (data.length == 0) {
            alert("No Speicification Found!!!");
            return;
          }
          let groupedData = Object.values(
            data.reduce((acc, curr, index) => {
              const key = curr.product_id ?? `no_product_${index}`;
              if (!acc[key]) {
                acc[key] = {
                  product_id: curr.product_id ?? null, // keep actual null for clarity
                };
              }
              return acc;
            }, {})
          );
          groupedData.map((c, index) => {
            let sino = index + 1;
            data.map((v) => {
              if (c.product_id == v.product_id) {
                c.discount = v.discount_percentage;
                let dnp = context.convertToNumber(v.dnp);
                let price = context.convertToNumber(v.prize);
                let tax = context.convertToNumber(v.tax);
                c.dnp = context.convertToNumber(dnp + ((dnp * tax) / 100)).toFixed(0);
                c.price = context.convertToNumber(price + ((price * tax) / 100)).toFixed(0);
                c.sino = sino;
                c.stock = v.no_stock;
                c.itemcode = v.item_number;
                c.tax = v.tax;
                c[v.specification_master_id] = v.specification_value;
              }
            })
          })
          const uniqueByMaster = Object.values(
            data.reduce((acc, curr) => {
              if (!acc[curr.specification_master_id]) {
                acc[curr.specification_master_id] = curr;
              }
              return acc;
            }, {})
          );
          console.log(groupedData);
          
          context.setState({ specification: uniqueByMaster, addSpecificationDialog: true, specificationData: groupedData  });
        } catch (e) {
          alert('Error!!!')
        }
      },
    });
  }

  convertToNumber = (value) => {
    try { value = Number(value); }
    catch (e) { value = 0; }
    return value;
  }

  addSpecificationRow() {
    let specification = this.state.specification;
    let categoryId = 0;
    let id = 0;
    specification.map((c) => { categoryId = c.category_id; id = c.id; });
    id = id + 1;
    specification.push({ category_id: categoryId, specification: '', value: '', type: 'add', id: id });
    console.log(specification);
    this.setState({ specification })
  }

  saveSpecification() {
    let context = this;
    let specificationData = this.state.specificationData;
    let url_string = window.location.href; var url = new URL(url_string);
    var shopId = url.searchParams.get("shopId");
    for (let index = 0; index < specificationData.length; index++) {
      let v = specificationData[index];
      let tax = context.convertToNumber(v.tax);
      let dnp = context.convertToNumber(v.dnp);
      let price = context.convertToNumber(v.price);
      if (tax < 10) { tax = '1.0' + tax; }
      else { tax = '1.' + tax; }
      tax = context.convertToNumber(tax);
      v.dnp = (dnp / tax).toFixed(2);
      v.price = (price / tax).toFixed(2);
    }
    let data = { specificationData: JSON.stringify(specificationData), productId: this.props.productId, shopId };
    this.setState({ loading: true });
    $.ajax({
      type: 'POST', data: data, url: serverName() + '/specification/savespecifications.php',
      success: function(data) {
        if (data == 1) {
          alert("Variants Added Successfully!!!");
          context.setState({ addSpecificationDialog: false });
          window.location.reload();
        }
        else {
          this.setState({ loading: false });
          alert("Failed To Add Variants!!!");
        }
      },
    });
  }

  textHandle = (type, id) => event => {
    let specification = this.state.specification;
    specification.map((v) => {
      if (v.id == id) {
         v.value = event.target.value;
         v.type = 'valueChanged';
      }
    })
    console.log(specification);
    this.setState({ specification })
  }

  addSpecification = () => {
    let specificationData = this.state.specificationData;
    let sino = specificationData.length + 1;
    let tax = specificationData[0].tax
    specificationData.push({ sino: sino, itemcode: '', dnp: '', price: '', stock: '', discount: '', status: '', view: '', tax });
    this.setState({ specificationData });
  }

  removeSpecification = (sino) => {
    alert(sino)
    return;
    let specificationData = this.state.specificationData;
    let newSpecificationData = [];
    let serialNo = 0;
    specificationData.map((v) => {
      if (v.sino != sino) {
        serialNo = serialNo + 1;
        v.sino = serialNo;
        newSpecificationData.push(v);
      }
    })
    this.setState({ specificationData: newSpecificationData });
  }

  textHandle = (type, sino) => event => { 
    let specificationData = this.state.specificationData;
    specificationData.map((v) => {
      if (v.sino == sino) {
        v[type] = event.target.value;
      }
    }
    )
    this.setState({ specificationData });
  }

  render() {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var shopId = url.searchParams.get("shopId");
    return (
      <div>
        <Button primary onClick={this.getSpecification.bind(this)} fluid>
          Add Variants
        </Button>
        <Dialog 
          fullWidth={true}
          maxWidth={"xl"}
          open={this.state.addSpecificationDialog}
          onClose={ () => { this.setState({ addSpecificationDialog:false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="simple-dialog-title">Variants</DialogTitle>
          <DialogContent>
          <Table>
              <TableHeader>
               <TableRow>
                  <TableHeaderCell width={1}>Sino</TableHeaderCell>
                  <TableHeaderCell width={1}>Product Id</TableHeaderCell>
                  <TableHeaderCell width={1}>Item Code</TableHeaderCell>
                  {
                    this.state.specification.map((v) => {
                      return (
                        <TableHeaderCell width={1}>{v.specification_master_name}</TableHeaderCell>
                      )
                    })
                  }
                  <TableHeaderCell width={1}>DNP</TableHeaderCell>
                  <TableHeaderCell width={1}>Price</TableHeaderCell>
                  <TableHeaderCell width={1}>Stock</TableHeaderCell>
                  {/* <TableHeaderCell width={1}>Discount</TableHeaderCell> */}
                  <TableHeaderCell width={1}>Delete</TableHeaderCell>
                  <TableHeaderCell width={1}>View</TableHeaderCell>
                </TableRow>
                {
                  this.state.specificationData.map((c) => {
                    return (
                      <TableRow disabled={c.product_id == this.props.productId ? true : false} style={c.product_id == this.props.productId ? { backgroundColor: '#f0f0f0' } : {}}>
                        <TableCell>{c.sino}</TableCell> 
                        <TableCell>{c.product_id}</TableCell> 
                        <TableCell>
                          <Input type="text" value={c.itemcode} 
                            onChange={this.textHandle('itemcode', c.sino)} /> 
                        </TableCell>
                        { this.state.specification.map((v) => {
                          return (
                            <TableCell>
                              <Input disabled={c.product_id == this.props.productId ? true : false} type="text" value={c[v.specification_master_id]} 
                                onChange={this.textHandle(v.specification_master_id, c.sino)} /> 
                            </TableCell>
                          )
                        }) }
                        <TableCell>
                          <Input disabled={c.product_id == this.props.productId ? true : false} type="text" value={c.dnp} 
                            onChange={this.textHandle('dnp', c.sino)} />
                        </TableCell>
                        <TableCell>
                          <Input type="text" value={c.price} disabled={c.product_id == this.props.productId ? true : false}
                            onChange={this.textHandle('price', c.sino)} />
                        </TableCell>
                        <TableCell>
                          <Input type="text" value={c.stock} disabled={c.product_id == this.props.productId ? true : false}
                            onChange={this.textHandle('stock', c.sino)} />
                        </TableCell>
                        {/* <TableCell>
                          <Input type="text" value={c.discount}
                            onChange={this.textHandle('discount', c.sino)} />
                        </TableCell> */}
                        <TableCell>
                          <Button  disabled={c.product_id ? true : false} onClick={this.removeSpecification.bind(this, c.sino)}>Delete</Button>
                        </TableCell>
                        <TableCell>
                          <a style={{ color: "blue" }} href={`edit-product?id=${c.product_id}&from=stocks&shopId=${shopId}`}>View</a>
                        </TableCell>
                      </TableRow>
                    )    
                  })
                }
              </TableHeader>
            </Table>
            <center><Button onClick={this.addSpecification} color="primary" autoFocus>Add Variants</Button></center>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ addSpecificationDialog:false }) }} color="primary">Cancel</Button>
            <Button onClick={this.saveSpecification.bind(this)} loading={this.state.loading} color="primary" autoFocus>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Specification;
